import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSession } from '../selectors/session.selector';
import { sessionActions } from '../actions/session.actions';

@Service()
export class SessionFacade {
    private readonly store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((user) => user !== null));
    readonly loading$ = this.store.select(selectLoading).pipe(filter((data) => data !== null));
    readonly session$ = this.store.select(selectSession);
    readonly sessionNonNullable$ = this.store.select(selectSession).pipe(filter((user) => user !== null));

    readonly session = this.store.selectSignal(selectSession);

    getSession(): void {
        this.store.dispatch(sessionActions.getSession());
    }

    clear(): void {
        this.store.dispatch(sessionActions.clear());
    }
}
